import { useCallback, useState } from 'react';

import { RequestStatus } from 'core/domain/Request';
import { signOut } from 'core/utils/signout';
import { PBIExportableReport, PBIReport } from 'managed-analytics/domain/PBIReport';
import { getPBIExportableReports, getPBIReports } from 'managed-analytics/use-cases/getPBIReports';

export function usePBIReports() {
  const [reports, setReports] = useState<Array<PBIReport>>([])
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.Initial)

  const isLoading = status === RequestStatus.Pending


  const getReports = useCallback(async (config?: AbortController) => {
    setStatus(RequestStatus.Pending)

    try {
      const reports = await getPBIReports(config)
      setReports(reports)
      setStatus(RequestStatus.Done)
    } catch (error: any) {
      if (config?.signal.aborted) return
      if (error.status = '401'){
        await signOut();
      } 
      else{
        setStatus(RequestStatus.Error)
      }
      
      setReports([])

      throw error
    }
  }, [])

  return {
    isLoading,
    status,
    reports,
    getReports,
  }
}


export function usePBIExportableReports() {
  const [reports, setReports] = useState<Array<PBIExportableReport>>([])
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.Initial)

  const isLoading = status === RequestStatus.Pending

  const getExportableReports = useCallback(async (config?: AbortController) => {
    setStatus(RequestStatus.Pending)

    try {
      const reports = await getPBIExportableReports(config)
      setReports(reports)
      setStatus(RequestStatus.Done)
    } catch (error: any) {
      if (config?.signal.aborted) return
      if (error.status = '401'){
        await signOut();
      } 
      else{
        setStatus(RequestStatus.Error)
      }
      
      setReports([])

      throw error
    }
  }, [])

  return {
    isLoading,
    status,
    reports,
    getExportableReports,
  }
}